"use strict";
var Observable_1 = require('../../Observable');
var sample_1 = require('../../operator/sample');
Observable_1.Observable.prototype.sample = sample_1.sample;
//# sourceMappingURL=sample.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/add/operator/sample.js
// module id = ./node_modules/rxjs/add/operator/sample.js
// module chunks = 0